export const BUTTON_CLASS_NAME = 'align-items-center justify-content-center d-flex';
export const BUTTON_STYLES = {
  width: '38px',
  height: '38px',
};
